module.exports = __webpack_public_path__ + "img/enTxt1.edbd0b91.png";